export default{
    label: '首席产品官（CPO）',
    id: '0',
    children: [
      {
        label: '定义',
        id: '0-1',
        children: [
          {
            label: 'CPO是企业产品战略的顶层设计者，属于公司高管层（C-Level），直接向 CEO 汇报。负责全局产品规划与创新，驱动产品与公司商业目标的深度结合，确保产品在市场上的长期竞争力。',
            id: '0-1-1',
          },
          ],
      },
      {
        label: '职责',
        id: '0-2',
        children: [
          {
            label: '定义产品愿景和战略，确保产品路线图与公司战略一致；预测市场趋势，制定差异化策略。',
            id: '0-2-1',
          },  
        ],
      },
      {
        label: '技能要求',
        id: '0-3',
        children: [
          {
            label: '拥有深厚的产品管理经验和市场洞察力，具备较强的领导力和跨部门协作能力。',
            id: '0-3-1',
          },
          ],
      },
      {
        label: '职业发展',
        id: '0-4',
        children: [
          {
            label: '是公司最高产品决策者，通常与CEO同级。',
            id: '0-4-1',
          },
          ],
      },
      {
        label: '薪资水平',
        id: '0-5',
        children: [
          {
            label: '年薪100万元以上',
            id: '0-5-1',
          },
          ],
      },
    ],
};